"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var core_1 = require("@apollo/client/core");
var graphql_1 = require("../utils/graphql");
var discount_1 = require("../utils/discount");
var constant_1 = require("../utils/constant");
var wrapper_1 = require("../utils/wrapper");
var utils_1 = require("../model/utils");
var discountByResourceId = function (resourceId) { return __awaiter(void 0, void 0, void 0, function () {
    var gqlResourceString, result, discounts;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                gqlResourceString = "\"" + resourceId + "\"";
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.query({
                        query: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            query discountByresourceId {\n              discounts(resourceId: ", ") {\n                  ", "\n              }\n            }"], ["\n            query discountByresourceId {\n              discounts(resourceId: ", ") {\n                  ", "\n              }\n            }"])), gqlResourceString, constant_1.FIRST_LEVEL_DISCOUNT),
                    }))];
            case 1:
                result = _b.sent();
                discounts = (result === null || result === void 0 ? void 0 : result.data).discounts;
                return [2 /*return*/, discount_1.discountsFactory(discounts)];
        }
    });
}); };
var discountById = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var result, discount_2, err_1, gqlError;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 2, , 3]);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.query({
                        query: core_1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                query discountById {\n                  discount(id: ", ") {\n                  ", "\n                  }\n                }"], ["\n                query discountById {\n                  discount(id: ", ") {\n                  ", "\n                  }\n                }"])), id, constant_1.FIRST_LEVEL_DISCOUNT),
                    }))];
            case 1:
                result = _e.sent();
                discount_2 = (result === null || result === void 0 ? void 0 : result.data).discount;
                return [2 /*return*/, { data: discount_1.discountFactory(discount_2) }];
            case 2:
                err_1 = _e.sent();
                gqlError = {
                    message: (_d = (_c = (_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.networkError) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.errors[0]) === null || _d === void 0 ? void 0 : _d.message,
                };
                return [2 /*return*/, utils_1.mkpErrorHandler(gqlError)];
            case 3: return [2 /*return*/];
        }
    });
}); };
var rawFetchDiscount = function (fct, how, what) { return __awaiter(void 0, void 0, void 0, function () {
    var queryBuilder, query, result, discounts, err_2, gqlError;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 2, , 3]);
                queryBuilder = graphql_1.gqlQueryBuilder(fct, how, what);
                query = String.raw(templateObject_3 || (templateObject_3 = __makeTemplateObject(["query rawFetchDiscount {  ", " }"], ["query rawFetchDiscount {  ", " }"])), queryBuilder);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.query({
                        query: core_1.gql(query),
                    }))];
            case 1:
                result = _e.sent();
                discounts = (result === null || result === void 0 ? void 0 : result.data).discounts;
                return [2 /*return*/, discount_1.discountsFactory(discounts)];
            case 2:
                err_2 = _e.sent();
                gqlError = {
                    message: (_d = (_c = (_b = err_2 === null || err_2 === void 0 ? void 0 : err_2.networkError) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.errors[0]) === null || _d === void 0 ? void 0 : _d.message,
                };
                return [2 /*return*/, gqlError];
            case 3: return [2 /*return*/];
        }
    });
}); };
var createDiscount = function (discountParams) { return __awaiter(void 0, void 0, void 0, function () {
    var createDiscountMutation, discount_3, res, err_3;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                createDiscountMutation = core_1.gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        mutation createDiscount($resourceId:String, $range:RangeInput, $discount:Float, $companyCode:String) {\n            createDiscount(resourceId:$resourceId, range:$range, discount:$discount, companyCode:$companyCode) {\n               ", "\n            }\n        }"], ["\n        mutation createDiscount($resourceId:String, $range:RangeInput, $discount:Float, $companyCode:String) {\n            createDiscount(resourceId:$resourceId, range:$range, discount:$discount, companyCode:$companyCode) {\n               ", "\n            }\n        }"])), constant_1.FIRST_LEVEL_DISCOUNT);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.mutate({
                        mutation: createDiscountMutation,
                        variables: discountParams,
                    }))];
            case 2:
                discount_3 = _c.sent();
                res = (_b = discount_3 === null || discount_3 === void 0 ? void 0 : discount_3.data) === null || _b === void 0 ? void 0 : _b.createDiscount;
                return [2 /*return*/, { data: discount_1.discountFactory(res) }];
            case 3:
                err_3 = _c.sent();
                return [2 /*return*/, utils_1.mkpErrorHandler(graphql_1.gqlErrorFactory(err_3))];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateDiscount = function (discountParams) { return __awaiter(void 0, void 0, void 0, function () {
    var updateDiscountMutation, updatedDiscount, res, err_4;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                updateDiscountMutation = core_1.gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        mutation updateDiscount($id: Int, $resourceId:String, $range:RangeInput, $discount:Float, $companyCode:String) {\n            updateDiscount(id: $id, resourceId:$resourceId, range:$range, discount:$discount, companyCode:$companyCode) {\n               ", "\n            }\n        }"], ["\n        mutation updateDiscount($id: Int, $resourceId:String, $range:RangeInput, $discount:Float, $companyCode:String) {\n            updateDiscount(id: $id, resourceId:$resourceId, range:$range, discount:$discount, companyCode:$companyCode) {\n               ", "\n            }\n        }"])), constant_1.FIRST_LEVEL_DISCOUNT);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.mutate({
                        mutation: updateDiscountMutation,
                        variables: discountParams,
                    }))];
            case 2:
                updatedDiscount = _c.sent();
                res = (_b = updatedDiscount === null || updatedDiscount === void 0 ? void 0 : updatedDiscount.data) === null || _b === void 0 ? void 0 : _b.updateDiscount;
                return [2 /*return*/, { data: discount_1.discountFactory(res) }];
            case 3:
                err_4 = _c.sent();
                return [2 /*return*/, utils_1.mkpErrorHandler(graphql_1.gqlErrorFactory(err_4))];
            case 4: return [2 /*return*/];
        }
    });
}); };
var createRecurrentDiscount = function (recurrentDiscountParams) { return __awaiter(void 0, void 0, void 0, function () {
    var createRecurrentDiscountMutation, recurrentDiscounts, res, err_5;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                createRecurrentDiscountMutation = core_1.gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        mutation(\n            $discount: Float,\n            $resourceId: String,\n            $occurrences: Int,\n            $range: RangeInput,\n            $rules: String,\n            $companyCode: String,\n        ) {\n            createRecurrentDiscount(\n                discount: $discount,\n                resourceId: $resourceId,\n                companyCode: $companyCode,\n                occurrences: $occurrences,\n                rules: $rules,\n                range: $range,\n            ){", "}\n        }"], ["\n        mutation(\n            $discount: Float,\n            $resourceId: String,\n            $occurrences: Int,\n            $range: RangeInput,\n            $rules: String,\n            $companyCode: String,\n        ) {\n            createRecurrentDiscount(\n                discount: $discount,\n                resourceId: $resourceId,\n                companyCode: $companyCode,\n                occurrences: $occurrences,\n                rules: $rules,\n                range: $range,\n            ){", "}\n        }"])), constant_1.FIRST_LEVEL_DISCOUNT);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.mutate({
                        mutation: createRecurrentDiscountMutation,
                        variables: recurrentDiscountParams,
                    }))];
            case 2:
                recurrentDiscounts = _c.sent();
                res = (_b = recurrentDiscounts === null || recurrentDiscounts === void 0 ? void 0 : recurrentDiscounts.data) === null || _b === void 0 ? void 0 : _b.createRecurrentDiscount;
                return [2 /*return*/, { data: res.map(discount_1.discountFactory) }];
            case 3:
                err_5 = _c.sent();
                return [2 /*return*/, utils_1.mkpErrorHandler(graphql_1.gqlErrorFactory(err_5))];
            case 4: return [2 /*return*/];
        }
    });
}); };
var deleteDiscount = function (discountId) { return __awaiter(void 0, void 0, void 0, function () {
    var deleteDiscountMutation, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                deleteDiscountMutation = core_1.gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        mutation deleteDiscount($id: Int) {\n            deleteDiscount(id: $id) {\n                id\n            }\n        }\n    "], ["\n        mutation deleteDiscount($id: Int) {\n            deleteDiscount(id: $id) {\n                id\n            }\n        }\n    "])));
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.mutate({
                        mutation: deleteDiscountMutation,
                        variables: { id: discountId },
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/, { data: true }];
            case 3:
                e_1 = _b.sent();
                return [2 /*return*/, utils_1.mkpErrorHandler(graphql_1.gqlErrorFactory(e_1))];
            case 4: return [2 /*return*/];
        }
    });
}); };
var deleteRecurrentDiscount = function (recurrentDiscountId) { return __awaiter(void 0, void 0, void 0, function () {
    var deleteRecurrentDiscountMutation, e_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                deleteRecurrentDiscountMutation = core_1.gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        mutation deleteRecurrentDiscount($id: Int) {\n            deleteRecurrentDiscount(id: $id) {\n                id\n            }\n        }\n    "], ["\n        mutation deleteRecurrentDiscount($id: Int) {\n            deleteRecurrentDiscount(id: $id) {\n                id\n            }\n        }\n    "])));
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, ((_a = wrapper_1.getClients().graphqlClient) === null || _a === void 0 ? void 0 : _a.mutate({
                        mutation: deleteRecurrentDiscountMutation,
                        variables: { id: recurrentDiscountId },
                    }))];
            case 2:
                _b.sent();
                return [2 /*return*/, { data: true }];
            case 3:
                e_2 = _b.sent();
                return [2 /*return*/, utils_1.mkpErrorHandler(graphql_1.gqlErrorFactory(e_2))];
            case 4: return [2 /*return*/];
        }
    });
}); };
var discount = {
    discountById: discountById,
    discountByResourceId: discountByResourceId,
    createDiscount: createDiscount,
    updateDiscount: updateDiscount,
    rawFetchDiscount: rawFetchDiscount,
    deleteDiscount: deleteDiscount,
    createRecurrentDiscount: createRecurrentDiscount,
    deleteRecurrentDiscount: deleteRecurrentDiscount,
};
var init = function () { return discount; };
exports.init = init;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
